import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/activity")({
  component: ActivityLayout,
});

function ActivityLayout() {
  return <Outlet />;
}
